import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "emotion-grid"
    }}>{`Emotion grid`}</h1>
    <p>{`A responsive (mobile-first) grid system built with emotion.`}</p>
    <h2 {...{
      "id": "installation"
    }}>{`Installation`}</h2>
    <p>{`You can use `}<strong parentName="p">{`yarn`}</strong>{` or `}<strong parentName="p">{`npm`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Emotion is used has peerDependencie, so you need install to.`}</p>
    </blockquote>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`yarn add @emotion/react @emotion/styled @mverissimoo/emotion-grid
`}</code></pre>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic Usage`}</h2>
    <p>{`You can create a basic grid system by using a single set of Row and Col grid assembly, all of the columns (Col) must be placed in Row..`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Container, Row, Col } from '@mverissimoo/emotion-grid';

function Page() {
  return (
    <Container>
      <Row>
        <Col xs={4} md={6} xl={12}>
          Col
        </Col>
        <Col xs={4} md={6} xl={12}>
          Col
        </Col>
      </Row>
    </Container>
  );
}

export default Page;
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      